/**
 * Projektliste nach Phase (Plan Projekt-Tracking, Etappe 3): Gruppen in
 * Arbeitsreihenfolge — oben, wo jetzt jemand handeln muss, unten, was läuft oder
 * wartet. Abgeschlossen und Verloren stehen zugeklappt am Ende; sie haben keine
 * Phase (die Übersicht rechnet nur laufende Projekte) und gehen nach dem Status.
 */
import type { ProjektUebersicht } from "./types";
import type { ProjektPhaseZeile } from "./projektLage";

export type PhasenGruppeKey =
  | "planen" | "zahlung" | "abrechnen" | "fertig" | "angebot" | "arbeit" | "anfrage" | "pausiert"
  | "ohne" | "abgeschlossen" | "verloren";

export const PHASEN_GRUPPEN: { key: PhasenGruppeKey; titel: string; zu?: boolean }[] = [
  { key: "planen", titel: "Zu planen" },
  { key: "zahlung", titel: "Wartet auf Zahlung" },
  { key: "abrechnen", titel: "Abrechnungsbereit" },
  { key: "fertig", titel: "Bereit zum Abschluss" },
  { key: "angebot", titel: "Angebot beim Kunden" },
  { key: "arbeit", titel: "In Arbeit" },
  { key: "anfrage", titel: "Anfrage" },
  { key: "pausiert", titel: "Pausiert" },
  { key: "ohne", titel: "Ohne Phase" },
  { key: "abgeschlossen", titel: "Abgeschlossen", zu: true },
  { key: "verloren", titel: "Verloren", zu: true },
];

export type PhasenGruppe = {
  key: PhasenGruppeKey;
  titel: string;
  zu: boolean;
  items: ProjektUebersicht[];
  /** Nur „Wartet auf Zahlung": wie viele davon überfällig sind. */
  ueberfaellig: number;
};

export function gruppeFuer(p: ProjektUebersicht, phasen: Record<string, ProjektPhaseZeile>): PhasenGruppeKey {
  const s = (p.status || "").toLowerCase();
  if (s.includes("abgeschlossen")) return "abgeschlossen";
  if (s.includes("verloren")) return "verloren";
  const z = phasen[p.id];
  if (!z) return "ohne";
  return (PHASEN_GRUPPEN.some((g) => g.key === z.phase) ? z.phase : "ohne") as PhasenGruppeKey;
}

export function nachPhase(projekte: ProjektUebersicht[], phasen: Record<string, ProjektPhaseZeile>): PhasenGruppe[] {
  const map = new Map<PhasenGruppeKey, ProjektUebersicht[]>();
  for (const p of projekte) {
    const k = gruppeFuer(p, phasen);
    map.set(k, [...(map.get(k) || []), p]);
  }
  return PHASEN_GRUPPEN.filter((g) => map.has(g.key)).map((g) => {
    const items = map.get(g.key) || [];
    return {
      key: g.key,
      titel: g.titel,
      zu: !!g.zu,
      items,
      ueberfaellig: g.key === "zahlung" ? items.filter((p) => phasen[p.id]?.ueberfaellig).length : 0,
    };
  });
}
